import { useTranslation } from 'react-i18next'
import { Result, Button, Space, Empty, Form, Menu, Dropdown } from 'antd'
import {
  FileExcelOutlined,
  PlusOutlined,
  SearchOutlined,
  SmileOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import {
  ContainerFunction,
  ContainerSearch,
  ContainerTable,
  CopyOutlinedIcon,
  DeleteOutlinedIcon,
  DivFunction,
  DivListFunction,
  DivRight,
  DownloadOutlinedIcon,
  FileExcelOutlinedIcon,
  FilePdfOutlinedIcon,
  FormOutlinedIcon,
  InputCustom,
  MailOutlinedIcon,
  PrinterOutlinedIcon,
  RedoOutlinedIcon,
  SendOutlinedIcon,
  SpanNotYetReleasedTd,
  StopOutlinedIcon,
} from 'features/TaxDeductionDocuments/styled'
import { EllipsisDiv } from 'features/Taxpayer/styled'
import { ButtonSave, TableCustom } from 'features/TaxDeduction/styled'
import Utils, {
  convertDate,
  findObjectInArray,
  padNumberWithZeros,
  removeItemByKeys,
} from 'general/utils/Utils'
import SelectOptions from 'general/constants/SelectOptions'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  thunkFindByTempapeRreleaseTaxDeductionDocuments,
  thunkUpdateCTDeductionDocuments,
} from 'features/TaxDeductionDocuments/taxDeductionDocumentsSlice'
import dayjs from 'dayjs'
import { shallowEqual, useDispatch } from 'react-redux'
import ToastHelper from 'general/helpers/ToastHelper'
import AlertTaxDectionDocumentsUpdate from 'features/TaxDeductionDocuments/component/Alert'
import {
  thunkFindAccountingDocument,
  thunkSignHSMAccountingDocument,
  thunkRemoveAccountingDocument,
  thunkCancelAccountingDocument,
  thunkExportAccountingDocument,
  thunkSendEmailAccountingDocument,
  thunkSendTaxAccountingDocument,
} from 'features/AccountingDocument/accountDoucmentsSlice'
import { debounce } from 'lodash'
import { thunkGetAccountProfile } from 'app/authSlice'
import { thunkGetCompanyProfile } from 'features/System/systemSlice'
import PopupCancelDocument from 'features/AccountingDocument/component/PopupCancelDocument'
import { saveAs } from 'file-saver'
import {
  DIGITAL_SIGN_METHOD,
  STATUS_ACCOUNTINGDOCUMENTS,
  TYPE_DOCUMENT,
} from 'general/constants/AppConstants'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import PopupSendEmail from 'features/AccountingDocument/component/PopupSendEmail'
import viVN from 'antd/es/locale/vi_VN'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import useFilter from 'hooks/useFilter'
import ModalUploadExcel from '../ModalUploadExcel'
import { useAppSelector } from 'hooks/useRedux'

function AccountingDocuments({ tabActive }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [templatepaperRelease, setTemplatepaperRelease] = useState(null)
  const [templatepaperExits, setTemplatepaperExits] = useState(null)
  const [openModalAlert, setOpenModalAlert] = useState(null)
  const [visibleRemove, setVisibleRemove] = useState(null)
  const [visibleCancel, setVisibleCancel] = useState(null)
  const [visibleSendGmail, setVisibleSendGmail] = useState(null)
  const [messageAlert, setMessageAlert] = useState(null)
  const [dataSource, setDataSource] = useState(null)
  const [typeSign, setTypeSign] = useState()
  const [dataActive, setDataActive] = useState()
  const [formCancel] = Form.useForm()
  const [disableCancel, setDisableCancel] = useState(false)
  const [disableGmail, setDisableGmail] = useState(false)
  const [disableSendTax, setDisableSendTax] = useState(false)
  const [formGmail] = Form.useForm()
  const [auth, setAuth] = useState({})
  const [registrationId, setRegistrationId] = useState(null)
  const [textSubmitUpdateTemplate, setTextSubmitUpdateTemplate] = useState('')
  const [panningDataSource, setPanningDataSource] = useState({
    page: 1,
    limit: 20,
    totalItems: 0,
    totalPages: 0,
    key: '',
  })
  const [inforItemTable, setInforItemTable] = useState({})
  const [modalStates, setModalStates] = useState({ show: false })
  const setDataInforItemTable = (inforItemTable, nameKey, key, value) => {
    const inforItemTableTemp = {
      ...inforItemTable,
      [nameKey]: {
        ...inforItemTable?.[nameKey],
        [key]: value, // Dùng dynamic key
      },
    }
    console.log(inforItemTableTemp)
    setInforItemTable(inforItemTableTemp)
  }
  const columns = [
    {
      title: t('accountingDocuments.numAd'),
      width: 150,
      className: 'center-header',
      // fixed: 'left',
      render: (text, record) => (
        <div className="left-cell">{record?.numberDocument}</div>
      ),
    },
    {
      title: t('accountingDocuments.codetc'),
      width: 150,
      className: 'center-header',
      // fixed: 'left',
      render: (text, record) => (
        <div className="left-cell">{record?.lookUpCode}</div>
      ),
    },
    {
      title: t('accountingDocuments.sendEmail'),
      width: 150,
      className: 'center-header',
      render: (text, record) => {
        const constStatus = findObjectInArray(
          SelectOptions.listStatusGamil,
          'value',
          record.statusSendEmail,
        )
        return (
          <div className="left-cell">
            <SpanNotYetReleasedTd
              color={constStatus?.color}
              backGroundColor={constStatus?.backGroundColor}
            >
              {constStatus?.label}
            </SpanNotYetReleasedTd>
          </div>
        )
      },
    },
    {
      title: t('accountingDocuments.status'),
      width: 180,
      className: 'center-header',
      render: (text, record) => {
        const constStatus = findObjectInArray(
          SelectOptions.listStatusAccountingDocuments,
          'value',
          record.status,
        )
        return (
          <div className="left-cell">
            <SpanNotYetReleasedTd
              color={constStatus?.color}
              backGroundColor={constStatus?.backGroundColor}
            >
              {constStatus?.label}
            </SpanNotYetReleasedTd>
          </div>
        )
      },
    },
    {
      title: t('accountingDocuments.statusSendTax'),
      width: 180,
      className: 'center-header',
      render: (text, record) => {
        const constStatus = findObjectInArray(
          SelectOptions.listStatusTaxAccountingDocuments,
          'value',
          record.statusSendTax != null ? record.statusSendTax : -1,
        )
        return (
          <div className="left-cell">
            <SpanNotYetReleasedTd
              color={constStatus?.color}
              backGroundColor={constStatus?.backGroundColor}
            >
              {constStatus?.label}
            </SpanNotYetReleasedTd>
          </div>
        )
      },
    },
    {
      title: t('accountingDocuments.codennt'),
      width: 150,
      className: 'center-header',
      // fixed: 'left',
      render: (text, record) => (
        <div className="left-cell">{record?.taxpayersCode}</div>
      ),
    },
    {
      title: t('Trạng thái chứng từ'),
      width: 150,
      className: 'center-header',
      render: (text, record) => (
        <div className="left-cell">
          {record?.type &&
            findObjectInArray(TYPE_DOCUMENT, 'value', record?.type)?.text}
        </div>
      ),
    },
    {
      title: t('taxpayer.taxpaperName'),
      width: 180,
      className: 'center-header',
      render: (text, record) => (
        <EllipsisDiv
          className="left-cell"
          width={180}
          title={record?.taxpayersName}
        >
          {record?.taxpayersName}
        </EllipsisDiv>
      ),
    },
    // {
    //   title: t('taxpayer.employeeBirthDate'),
    //   width: 110,
    //   className: 'center-header',
    //   render: (text, record) => (
    //     <div className="left-cell">
    //       {record.employeeBirthDate
    //         ? convertDate(record.employeeBirthDate, 'DD/MM/YYYY')
    //         : ''}
    //     </div>
    //   ),
    // },
    {
      title: t('accountingDocuments.taxCode'),
      width: 150,
      className: 'center-header',
      render: (text, record) => (
        <div className="left-cell">{record.employeeTaxCode}</div>
      ),
    },
    {
      title: t('accountingDocuments.emailnnt'),
      width: 250,
      className: 'center-header',
      render: (text, record) => (
        <EllipsisDiv
          className="left-cell"
          width={180}
          title={record?.employeeEmail}
        >
          {record?.employeeEmail}
        </EllipsisDiv>
      ),
    },
    {
      title: t('accountingDocuments.createdate'),
      width: 170,
      className: 'center-header',
      render: (text, record) => (
        <div className="center-cell">
          {record.createDate
            ? convertDate(record.createDate, 'DD/MM/YYYY HH:mm:ss')
            : ''}
        </div>
      ),
    },
    {
      title: t('accountingDocuments.time'),
      width: 130,
      className: 'center-header',
      render: (text, record) => (
        <div className="center-cell">
          {record.incomeStartMonth == record.lastIncomeMonth
            ? `${padNumberWithZeros(record?.incomeStartMonth, 2)}/${record?.incomeYear}`
            : `${padNumberWithZeros(record?.incomeStartMonth, 2)} - ${padNumberWithZeros(record?.lastIncomeMonth, 2)}/${record?.incomeYear}`}
        </div>
      ),
    },
    {
      title: t('accountingDocuments.kh'),
      width: 130,
      className: 'center-header',
      render: (text, record) => (
        <EllipsisDiv className="center-cell" width={130}>
          {record?.templatePaper?.formNumber == '03/TNCN'
            ? `${record?.templatePaper?.symbolCode}/${record?.templatePaper?.symbolYear?.toString()?.slice(2)}${record?.templatePaper?.symbolType}`
            : `${record?.templatePaper?.symbolCode}/${record?.templatePaper?.symbolYear}/${record?.templatePaper?.symbolType}`}
        </EllipsisDiv>
      ),
    },
    {
      title: t('accountingDocuments.circular'),
      width: 150,
      className: 'center-header',
      render: (text, record) => (
        <EllipsisDiv
          className="left-cell"
          width={150}
          title={record?.templatePaper?.circular}
        >
          {record?.templatePaper?.circular}
        </EllipsisDiv>
      ),
    },

    {
      title: t('accountingDocuments.address'),
      width: 300,
      className: 'center-header',
      render: (text, record) => (
        <EllipsisDiv
          className="left-cell"
          width={300}
          title={record?.employeeAddress}
        >
          {record?.employeeAddress}
        </EllipsisDiv>
      ),
    },
    // {
    //   title: t('accountingDocuments.personCreate'),
    //   width: 150,
    //   className: 'center-header',
    //   render: (text, record) => (
    //     <EllipsisDiv className="left-cell" width={150} title={``}></EllipsisDiv>
    //   ),
    // },
    {
      title: t('accountingDocuments.reson'),
      width: 250,
      className: 'center-header',
      render: (text, record) => (
        <EllipsisDiv className="left-cell" width={250} title={record?.reson}>
          {record?.reson}
        </EllipsisDiv>
      ),
    },
    {
      title: t('accountingDocuments.note'),
      width: 300,
      className: 'center-header',
      render: (text, record) => (
        <EllipsisDiv className="left-cell" width={300} title={record?.note}>
          {record?.note}
        </EllipsisDiv>
      ),
    },
    {
      title: t('accountingDocuments.dateCancel'),
      width: 170,
      className: 'center-header',
      render: (text, record) => (
        <div className="center-cell">
          {record.cancelDate
            ? convertDate(record.cancelDate, 'DD/MM/YYYY HH:mm:ss')
            : ''}
        </div>
      ),
    },

    {
      title: '',
      width: 0,
      className: 'center-header',
      fixed: 'right',
      render: (text, record, index) => {
        let listFunction = [
          {
            key: 'photo',
            title: t('taxDeductionDocuments.in'),
            icon: (
              <PrinterOutlinedIcon
                disabled={
                  inforItemTable?.exportFilePrin?.[
                    record?.accounting_documentsId
                  ]
                }
                display="inherit"
                onClick={() => {
                  setDataInforItemTable(
                    inforItemTable,
                    'exportFilePrin',
                    record.accounting_documentsId,
                    true,
                  )
                  exportFile('PDF', record.accounting_documentsId, 1)
                }}
              />
            ),
          },
          {
            key: 'remove',
            title: t('taxDeductionDocuments.remove'),
            icon: (
              <DeleteOutlinedIcon
                display="inherit"
                onClick={() => {
                  setDataActive({
                    accounting_documentsId: record.accounting_documentsId,
                    code: record.code,
                  })
                  setVisibleRemove(true)
                }}
              />
            ),
          },
          {
            key: 'edit',
            title: t('taxDeductionDocuments.editt'),
            icon: (
              <FormOutlinedIcon
                display="inherit"
                onClick={() => {
                  if (record?.adjustId) {
                    navigate(
                      `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?accounting_documents=${record.accounting_documentsId}&statusDocument=adjust`,
                    )
                  } else {
                    navigate(
                      `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?accounting_documents=${record.accounting_documentsId}`,
                    )
                  }
                }}
              />
            ),
          },
          {
            key: 'release',
            title: t('taxDeductionDocuments.pt'),
            icon: (
              <SendOutlinedIcon
                disabled={
                  inforItemTable?.exportFileSign?.[
                    record.accounting_documentsId
                  ]
                }
                color="#007aff !important"
                display="inherit"
                onClick={() => {
                  setDataInforItemTable(
                    inforItemTable,
                    'exportFileSign',
                    record.accounting_documentsId,
                    true,
                  )
                  sign(record?.accounting_documentsId)
                }}
              />
            ),
          },
          // {
          //   key: 'cancelDocuments',
          //   title: t('accountingDocuments.hph'),
          //   icon: (
          //     <StopOutlinedIcon
          //       color="red !important"
          //       display="inherit"
          //       onClick={() => {
          //         setDataActive({
          //           accounting_documentsId: record.accounting_documentsId,
          //           code: record.code,
          //         })
          //         setVisibleCancel(true)
          //       }}
          //     />
          //   ),
          // },
          {
            key: 'sendDocumentsTax',
            title: t('accountingDocuments.glcqt'),
            icon: (
              <RedoOutlinedIcon
                color="green !important"
                display="inherit"
                disabled={disableSendTax}
                onClick={async () => {
                  await sendTax(record)
                }}
              />
            ),
          },

          {
            key: 'copy',
            title: t('taxDeductionDocuments.copy'),
            icon: (
              <CopyOutlinedIcon
                display="inherit"
                onClick={async () => {
                  let date = record?.templatePaper?.symbolYear
                    ? record?.templatePaper?.symbolYear
                    : new Date(record.createDate).getUTCFullYear()
                  if (
                    record?.templatePaper?.symbolYear ==
                    new Date().getFullYear()
                  ) {
                    navigate(
                      `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?accounting_documents=${record.accounting_documentsId}&type=copy`,
                    )
                  } else {
                    let result = await getTemplatepaperRelease()
                    if (result && result?.data?.templatePaperId) {
                      navigate(
                        `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?accounting_documents=${record.accounting_documentsId}&type=copy`,
                      )
                    } else {
                      setOpenModalAlert(true)
                      if (registrationId) {
                        if (templatepaperExits) {
                          setMessageAlert(
                            t('accountingDocuments.notTemplateRealead', {
                              value: dayjs().year(),
                            }),
                          )
                        } else {
                          setMessageAlert(
                            t('accountingDocuments.notSignTemplateRealead', {
                              value: dayjs().year(),
                            }),
                          )
                        }
                      } else {
                        setMessageAlert(
                          t('accountingDocuments.notRegistrationRealead'),
                        )
                      }
                    }
                  }
                }}
              />
            ),
          },
          {
            key: 'gmail',
            title: t('accountingDocuments.sendEmail'),
            icon: (
              <MailOutlinedIcon
                display="inherit"
                onClick={() => {
                  setDataActive({
                    accounting_documentsId: record.accounting_documentsId,
                    code: record.code,
                    taxpayersName: record.taxpayersName,
                    employeeEmail: record.employeeEmail,
                  })
                  setVisibleSendGmail(true)
                }}
              />
            ),
          },

          {
            key: 'export',
            title: t('taxDeductionDocuments.exportTemplate'),
            icon: (
              <Space direction="vertical">
                <Space wrap>
                  <Dropdown
                    overlay={createMenu(
                      record.accounting_documentsId,
                      record.companyId,
                    )}
                    placement="bottomLeft"
                  >
                    <DownloadOutlinedIcon
                      display="inherit"
                      onClick={() => {}}
                    />
                  </Dropdown>
                </Space>
              </Space>
            ),
          },
        ]
        if (
          record.status === STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_CODE_GIVEN ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.SENDING_TAX ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_PROCESS ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_DENY
        ) {
          listFunction = removeItemByKeys(
            [...listFunction],
            ['edit', 'remove', 'release', 'cancelDocuments'],
          )
        } else if (record.status === STATUS_ACCOUNTINGDOCUMENTS.CANCELED) {
          listFunction = removeItemByKeys(
            [...listFunction],
            ['edit', 'remove', 'release', 'cancelDocuments'],
          )
        } else if (
          record.status === STATUS_ACCOUNTINGDOCUMENTS.NOT_SENT_TO_AUTHORITY
        ) {
          listFunction = removeItemByKeys(
            [...listFunction],
            ['cancelDocuments'],
          )
        }
        if (
          record.status === STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_CODE_GIVEN ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.SENDING_TAX ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_PROCESS ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_DENY ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.CANCELED ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.NOT_PRINT ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.PRINT ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.SIGN_ERROR ||
          record.status === STATUS_ACCOUNTINGDOCUMENTS.NOT_SENT_TO_AUTHORITY
        ) {
          listFunction = removeItemByKeys(
            [...listFunction],
            ['sendDocumentsTax'],
          )
        }
        return (
          <ContainerFunction className="left-cell">
            <DivListFunction className="listFuntionFlex">
              {listFunction.map((item, indexl) => (
                <DivFunction
                  title={item.title}
                  key={indexl}
                  right={`${indexl * 40}px`}
                >
                  {item.icon}
                </DivFunction>
              ))}
            </DivListFunction>
          </ContainerFunction>
        )
      },
    },
  ]

  useEffect(() => {
    const fetchData = async () => {
      const data = await dispatch(thunkGetAccountProfile())
      if (data?.payload) {
        const dataCompany = await dispatch(
          thunkGetCompanyProfile({
            companyId: data?.payload?.company?.companyId,
          }),
        )
        setTypeSign(dataCompany?.payload?.activeSigningMethod)
      }
      setAuth(data?.payload?.company)
    }
    fetchData()
  }, [dispatch])

  useEffect(() => {
    if (tabActive == 2) {
      getTemplatepaperRelease()
      findDataSource()
    }
  }, [tabActive])

  const [filterParams, setFilterParams] = useState({})

  // useFilter(
  //   'gFiltersAccountingDocumentsList',
  // )

  useEffect(() => {
    findDataSource(filterParams)
  }, [
    panningDataSource.page,
    panningDataSource.limit,
    panningDataSource.key,
    filterParams,
  ])

  const getTemplatepaperRelease = async () => {
    const result = unwrapResult(
      await dispatch(
        thunkFindByTempapeRreleaseTaxDeductionDocuments({
          year: dayjs().year(),
        }),
      ),
    )
    if (result?.message === 'success') {
      setTemplatepaperRelease(result?.data)
      setTemplatepaperExits(result?.dataExits)
      setRegistrationId(result?.registrationId)
      return result
    } else {
      setTemplatepaperRelease(null)
      setTemplatepaperExits(null)
      setRegistrationId(null)
      return null
    }
  }

  const createMenu = (accounting_documentsId) => (
    <Menu>
      <Menu.Item
        disabled={inforItemTable?.exportFilePDF?.[accounting_documentsId]}
        key="1"
        onClick={() => {
          setDataInforItemTable(
            inforItemTable,
            'exportFilePDF',
            accounting_documentsId,
            true,
          )
          exportFile('PDF', accounting_documentsId)
        }}
      >
        <b>
          <FilePdfOutlinedIcon
            style={{
              color: 'red',
              marginRight: '10px',
              position: 'relative',
              top: '-2px',
              display: 'inline',
            }}
          />
          PDF
        </b>
      </Menu.Item>
      <Menu.Item
        disabled={inforItemTable?.exportFileXML?.[accounting_documentsId]}
        key="2"
        onClick={() => {
          setDataInforItemTable(
            inforItemTable,
            'exportFileXML',
            accounting_documentsId,
            true,
          )
          exportFile('XML', accounting_documentsId)
        }}
      >
        <b>
          <FileExcelOutlinedIcon
            style={{
              color: '#304ffd',
              marginRight: '10px',
              position: 'relative',
              top: '-2px',
              display: 'inline',
            }}
          />
          XML
        </b>
      </Menu.Item>
    </Menu>
  )

  const findDataSource = async () => {
    console.log('filterParams', filterParams)
    try {
      const data = unwrapResult(
        await dispatch(
          thunkFindAccountingDocument({
            ...panningDataSource,
            endDate: filterParams?.endDate,
            startDate: filterParams?.startDate,
            status: filterParams?.status,
            statusSendTax: filterParams?.statusSendTax,
          }),
        ),
      )
      setDataSource(data.items)
      setPanningDataSource({
        ...panningDataSource,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
        endDate: filterParams?.endDate,
        startDate: filterParams?.startDate,
        status: filterParams?.status,
        statusSendTax: filterParams?.statusSendTax,
      })
    } catch (error) {}
  }

  const sign = async (accounting_documentsId) => {
    try {
      const result = unwrapResult(
        await dispatch(
          thunkSignHSMAccountingDocument({ accounting_documentsId, typeSign }),
        ),
      )
      if (result?.message == 'success') {
        if (typeSign == DIGITAL_SIGN_METHOD.HSM) {
          ToastHelper.showSuccess(t('accountingDocuments.sign'))
          resetResouce()
          findDataSource()
        } else {
          let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
          let urlSchema = `${process.env.REACT_APP_BASE_URL_SCHEMA}${accessToken},${auth.taxCode},${accounting_documentsId},AccountingDocuments`
          console.log('urlSchema', urlSchema)
          Utils.openToolSignAccountingDocuments(urlSchema, accessToken)
        }
      } else {
        findDataSource()
        ToastHelper.showError(result?.data)
      }
    } catch (error) {
    } finally {
      setDataInforItemTable(
        inforItemTable,
        'exportFileSign',
        accounting_documentsId,
        false,
      )
    }
  }

  const remove = async () => {
    try {
      const result = unwrapResult(
        await dispatch(thunkRemoveAccountingDocument(dataActive)),
      )
      if (result?.message == 'success') {
        ToastHelper.showSuccess(t('accountingDocuments.cancelSuc'))
        setVisibleRemove(false)
        findDataSource()
      } else {
        ToastHelper.showError(result?.data)
      }
    } catch (error) {}
  }

  const sendTax = async ({ accounting_documentsId }) => {
    try {
      setDisableSendTax(true)
      const result = unwrapResult(
        await dispatch(
          thunkSendTaxAccountingDocument({ accounting_documentsId }),
        ),
      )
      setDisableSendTax(false)
      if (result?.message == 'success') {
        ToastHelper.showSuccess(t('Gửi lên CQT thành công'))
        setVisibleRemove(false)
        findDataSource()
      } else {
        ToastHelper.showError(result?.data)
      }
    } catch (error) {
      setDisableSendTax(false)
    }
  }

  const cancel = async (data) => {
    try {
      const result = unwrapResult(
        await dispatch(thunkCancelAccountingDocument(data)),
      )
      setDisableCancel(false)
      if (result?.message == 'success') {
        ToastHelper.showSuccess(t('accountingDocuments.cancelSuc'))
        setVisibleCancel(false)
        findDataSource()
      } else {
        ToastHelper.showError(result?.data)
      }
    } catch (error) {}
  }

  const exportFile = async (typeFile, accounting_documentsId, view) => {
    const dataFile = await dispatch(
      thunkExportAccountingDocument({
        typeFile,
        accounting_documentsId,
      }),
    )
    if (typeFile == 'XML') {
      setDataInforItemTable(
        inforItemTable,
        'exportFileXML',
        accounting_documentsId,
        false,
      )
    } else {
      if (view) {
        setDataInforItemTable(
          inforItemTable,
          'exportFilePrin',
          accounting_documentsId,
          false,
        )
      } else {
        setDataInforItemTable(
          inforItemTable,
          'exportFilePDF',
          accounting_documentsId,
          false,
        )
      }
    }
    if (dataFile?.payload?.data && dataFile.payload.fileName) {
      const { data, fileName } = dataFile.payload
      if (data.type === 'Buffer') {
        const byteArray = new Uint8Array(data.data)
        const blob = new Blob([byteArray], {
          type: typeFile == 'XML' ? 'application/xml' : 'application/pdf',
        })
        if (view) {
          const url = URL.createObjectURL(blob)
          window.open(url, '_blank')
        } else {
          saveAs(blob, fileName)
        }
      } else {
        ToastHelper.showError('Invalid buffer data')
      }
    }
  }

  const sendEmail = async (values) => {
    try {
      let data = {
        ...values,
        ccEmails: values?.ccEmails
          ? values.ccEmails.split(';').map((email) => email.trim())
          : [],
        bccEmails: values?.bccEmails
          ? values.bccEmails.split(';').map((email) => email.trim())
          : [],
        accounting_documentsId: dataActive?.accounting_documentsId,
      }
      const result = unwrapResult(
        await dispatch(thunkSendEmailAccountingDocument(data)),
      )
      if (result?.message == 'success') {
        ToastHelper.showSuccess(t('accountingDocuments.sendsus'))
        setVisibleSendGmail(false)
        findDataSource()
      } else {
        ToastHelper.showError(result?.data)
        setDisableGmail(false)
        // setVisibleSendGmail(false)
      }
    } catch (error) {}
  }

  const resetResouce = async () => {
    return await dispatch(thunkGetAccountProfile())
  }

  const debouncedSetFormState = useCallback(
    debounce((keyValue, value) => {
      // Gọi API tại đây với keyValue và value
      setPanningDataSource((prevPanningDataSource) => ({
        ...prevPanningDataSource,
        [keyValue]: value,
      }))
    }, 600), // Thời gian chờ sau khi kết thúc nhập liệu, ví dụ: 500ms
    [], // Empty dependency array means this callback will only be created once
  )

  const handleChange = (key, value) => {
    // Xóa timeout hiện tại để tránh gọi API nếu người dùng vẫn đang nhập
    clearTimeout(timeoutId)

    // Thiết lập timeout mới với debounce
    timeoutId = setTimeout(() => {
      debouncedSetFormState(key, value)
    }, 500) // Đợi 500ms sau khi kết thúc nhập liệu
  }

  let timeoutId = null // Biến lưu trữ timeout ID

  const defaultValues = useMemo(() => {
    /** @type {Array<FilterDefaultValueProp>} */
    const arr = [
      {
        label: 'Trạng thái phát hành',
        alias: 'Trạng thái CT',
        formName: 'status',
        options: SelectOptions.listStatusAccountingDocuments,
        value: null,
      },
      {
        label: 'Trạng thái gửi CQT',
        alias: 'Trạng thái CT',
        formName: 'statusSendTax',
        options: SelectOptions.listStatusTaxAccountingDocuments,
        value: null,
      },
    ]
    return arr
  }, [])

  const onchangeDate = (name, value, dateRange) => {
    if (name) {
      console.log(value)
      // setDateSerial(getYearsFromDates({ ...filterParams, [name]: value }))
    } else {
      // setDateSerial(
      //   getYearsFromDates({
      //     ...filterParams,
      //     startDate: dateRange[0],
      //     endDate: dateRange[1],
      //   }),
      // )
    }
  }

  const updateCT = async () => {
    const data = unwrapResult(
      await dispatch(
        thunkUpdateCTDeductionDocuments({
          templatePaperId: templatepaperRelease.templatePaperId,
        }),
      ),
    )
    if (data.message === 'success') {
      ToastHelper.showSuccess('Cập nhật thành công')
      location.reload()
    } else if (data.message === 'error') {
      ToastHelper.showError(data?.data)
    }
  }

  return (
    <ContainerTable>
      <div className="pt-2 pb-5 row">
        <div className="col-sm-8">
          <Space.Compact>
            <InputCustom
              onChange={(e) => {
                handleChange('key', e.target.value)
              }}
              minWidth="300px"
              addonBefore={
                <SearchOutlined
                  onClick={() => {
                    findDataSource()
                  }}
                />
              }
              placeholder={t('taxpayer.keySearch')}
              allowClear
            />
          </Space.Compact>
          <span style={{ marginLeft: 5 }}>
            <FilterPopover
              menuPosition="bottomLeft"
              defaultValues={defaultValues}
              savedKey={'gFiltersAccountingDocumentsList'}
              onApply={setFilterParams}
              onchangeDate={onchangeDate}
            />
          </span>
        </div>
        <DivRight className="col-sm-4">
          <ButtonSave
            style={{ marginRight: 10 }}
            icon={<PlusOutlined />}
            type="primary"
            onClick={async () => {
              setTextSubmitUpdateTemplate(null)
              if (templatepaperRelease) {
                if (templatepaperRelease?.formNumber == '03/TNCN') {
                  if (templatepaperRelease?.symbolCode == 'CT') {
                    navigate(
                      `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?templatePaper=${templatepaperRelease.templatePaperId}`,
                    )
                  } else {
                    setOpenModalAlert(true)
                    setMessageAlert(
                      t('accountingDocuments.createtemplateNewData', {
                        valueCurrent: templatepaperRelease?.symbolCode,
                      }),
                    )
                    setTextSubmitUpdateTemplate('Cập nhật ngay')
                  }
                } else {
                  setOpenModalAlert(true)
                  setMessageAlert(
                    t('accountingDocuments.createtemplateNew', {
                      value: dayjs().year(),
                    }),
                  )
                }
              } else {
                let result = await getTemplatepaperRelease()
                if (result && result?.data?.templatePaperId) {
                  navigate(
                    `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?templatePaper=${result?.data?.templatePaperId}`,
                  )
                } else {
                  setOpenModalAlert(true)
                  if (registrationId) {
                    if (templatepaperExits) {
                      setMessageAlert(
                        t('accountingDocuments.notTemplateRealead', {
                          value: dayjs().year(),
                        }),
                      )
                    } else {
                      setMessageAlert(
                        t('accountingDocuments.notSignTemplateRealead', {
                          value: dayjs().year(),
                        }),
                      )
                    }
                  } else {
                    setMessageAlert(
                      t('accountingDocuments.notRegistrationRealead'),
                    )
                  }
                }
              }
            }}
          >
            {t('accountingDocuments.titleAdd')}
          </ButtonSave>
          <ButtonSave
            icon={<FileExcelOutlined />}
            type="primary"
            backGroundButtonSave="#52c41a"
            backGroundButtonSaveHover="#389e0d"
            onClick={async () => {
              setTextSubmitUpdateTemplate(null)
              if (templatepaperRelease) {
                if (templatepaperRelease?.formNumber == '03/TNCN') {
                  if (templatepaperRelease?.symbolCode == 'CT') {
                    // navigate(
                    //   `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?templatePaper=${templatepaperRelease.templatePaperId}`,
                    // )
                    setModalStates({ ...modalStates, show: true })
                  } else {
                    setOpenModalAlert(true)
                    setMessageAlert(
                      t('accountingDocuments.createtemplateNewData', {
                        valueCurrent: templatepaperRelease?.symbolCode,
                      }),
                    )
                    setTextSubmitUpdateTemplate('Cập nhật ngay')
                  }
                } else {
                  setOpenModalAlert(true)
                  setMessageAlert(
                    t('accountingDocuments.createtemplateNew', {
                      value: dayjs().year(),
                    }),
                  )
                }
              } else {
                let result = await getTemplatepaperRelease()
                if (result && result?.data?.templatePaperId) {
                  // navigate(
                  //   `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?templatePaper=${result?.data?.templatePaperId}`,
                  // )
                  setModalStates({ ...modalStates, show: true })
                } else {
                  setOpenModalAlert(true)
                  if (registrationId) {
                    if (templatepaperExits) {
                      setMessageAlert(
                        t('accountingDocuments.notTemplateRealead', {
                          value: dayjs().year(),
                        }),
                      )
                    } else {
                      setMessageAlert(
                        t('accountingDocuments.notSignTemplateRealead', {
                          value: dayjs().year(),
                        }),
                      )
                    }
                  } else {
                    setMessageAlert(
                      t('accountingDocuments.notRegistrationRealead'),
                    )
                  }
                }
              }
            }}
          >
            {t('accountingDocuments.updateExcel')}
          </ButtonSave>
        </DivRight>
      </div>
      <div style={{ marginBottom: 30 }}>
        {t('accountingDocuments.totalItem')}:{' '}
        <b>({panningDataSource.totalItems ?? 0})</b>
      </div>
      <button
        id="refetchAd"
        style={{ display: 'none' }}
        onClick={() => {
          findDataSource()
        }}
      >
        refetch
      </button>

      <TableCustom
        scroll={{ x: 1200 }}
        dataSource={dataSource}
        columns={columns}
        locale={{
          emptyText: <Empty description={t('taxDeduction.noData')} />,
        }}
        marginRight={'0px'}
        marginLeft={'0px'}
        pagination={
          panningDataSource.totalPages > 1
            ? {
                current: panningDataSource.page,
                pageSize: panningDataSource.limit,
                total: panningDataSource.totalItems,
              }
            : false
        }
        onChange={(pagination) => {
          setPanningDataSource({
            ...pagination,
            page: pagination.current,
            limit: pagination.pageSize,
          })
        }}
      />
      <AlertTaxDectionDocumentsUpdate
        titleCancel={t('taxDeduction.closeModal')}
        titlePrimary={
          textSubmitUpdateTemplate
            ? textSubmitUpdateTemplate
            : registrationId
              ? t('accountingDocuments.viewTemplate')
              : t('accountingDocuments.createRegistration')
        }
        openModalAlert={openModalAlert}
        titleAlert={t('accountingDocuments.notification')}
        messageAlert={messageAlert}
        setOpenModalAlert={(value) => {
          setOpenModalAlert(value)
        }}
        onClickPrimary={() => {
          textSubmitUpdateTemplate
            ? updateCT()
            : navigate(
                registrationId
                  ? '/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/mau'
                  : '/hoa-don-dau-ra/chung-tu-tncn/to-khai-tncn',
              )
        }}
      />
      {/* remove */}
      <AlertTaxDectionDocumentsUpdate
        titleCancel={t('taxDeductionDocuments.no')}
        titlePrimary={t('taxDeductionDocuments.remove')}
        openModalAlert={visibleRemove}
        titleAlert={t('accountingDocuments.removennt')}
        setOpenModalAlert={(value) => {
          setVisibleRemove(value)
        }}
        onClickPrimary={() => {
          remove()
        }}
        colorButtonSave={'#ffffff'}
        backGroundButtonSave={'#e61d1d'}
        backGroundButtonSaveHover={'#cc0202!important'}
        messageActive1={t('accountingDocuments.meremove1')}
        messageActive2={t('accountingDocuments.meremove2')}
        nameActive={dataActive?.code}
      />
      {/* cancel document */}
      <PopupCancelDocument
        visible={visibleCancel}
        setVisible={(value) => {
          setVisibleCancel(value)
        }}
        form={formCancel}
        submit={(value) => {
          cancel({
            ...value,
            accounting_documentsId: dataActive?.accounting_documentsId,
          })
        }}
        disableSave={disableCancel}
        setDisableSave={(value) => {
          setDisableCancel(value)
        }}
      />
      {/* send document */}
      <PopupSendEmail
        visible={visibleSendGmail}
        setVisible={(value) => {
          setVisibleSendGmail(value)
        }}
        form={formGmail}
        disableSave={disableGmail}
        setDisableSave={(value) => {
          setDisableGmail(value)
        }}
        submit={(data) => {
          sendEmail(data)
        }}
        dataActive={dataActive}
      />

      <ModalUploadExcel
        show={modalStates.show}
        setShow={(data) => setModalStates({ ...modalStates, ...data })}
        refetchListInvoice={findDataSource}
      />
    </ContainerTable>
  )
}
export default AccountingDocuments
